import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { HookDirective } from '../../core/hook';

export type TimelineEvent = {
  type: string;
  username?: string;
  date: string;
  displayContent: string;
};

@Component({
  selector: 'timeline-list',
  styleUrls: ['./timeline-list.component.scss'],
  templateUrl: './timeline-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineListComponent extends HookDirective {
  constructor(_cdr: ChangeDetectorRef) {
    super(_cdr);
  }

  @Input()
  events: TimelineEvent[];

  @Input()
  compareMethod: (a: TimelineEvent, b: TimelineEvent) => number = dateCompare;

  @Input()
  filterMethod: (event: TimelineEvent) => boolean = () => true;

  @Input()
  showTooltip: boolean = true;

  contentSize: { width: number; height: number };

  get _() {
    const filteredEvents = this.events.filter(event =>
      this.filterMethod(event),
    );

    const sortedEvents = filteredEvents.sort((a, b) =>
      this.compareMethod(a, b),
    );

    return { events: sortedEvents };
  }
}

function dateCompare(a: TimelineEvent, b: TimelineEvent) {
  if (a.date > b.date) return -1;
  if (a.date < b.date) return 1;

  return 0;
}
